module.exports = __webpack_public_path__ + "static/media/7.ce4d24f5.svg";